module.exports = [{"ammo":0,"fuel":50,"expeds":[2,4,5,7,9,11,12,14,31]},{"ammo":80,"fuel":80,"expeds":[23,26,27,28,35,36,37,38]},{"ammo":40,"fuel":50,"expeds":[13,15,16,19,20]},{"ammo":70,"fuel":80,"expeds":[21,22,40]},{"ammo":80,"fuel":50,"expeds":[25,33,34]},{"ammo":20,"fuel":50,"expeds":[8,18]},{"ammo":20,"fuel":30,"expeds":[3,6]},{"ammo":0,"fuel":30,"expeds":[1,10]},{"ammo":90,"fuel":90,"expeds":[39]},{"ammo":70,"fuel":90,"expeds":[30]},{"ammo":60,"fuel":90,"expeds":[24]},{"ammo":40,"fuel":90,"expeds":[29]},{"ammo":30,"fuel":90,"expeds":[32]},{"ammo":40,"fuel":30,"expeds":[17]}]


//////////////////
// WEBPACK FOOTER
// ./assets/exped-cost-grouping.json
// module id = 652
// module chunks = 0